(() => {
  function normalizeFinishHeading(headingEl) {
    if (!headingEl) return;
    const raw = headingEl.textContent;
    if (!raw || !/\\n|\r?\n/.test(raw)) return;
    const parts = raw
      .split(/\r?\n/)
      .flatMap((segment) => segment.split('\\n'))
      .map((s) => s.trim())
      .filter((s) => s.length > 0);
    if (parts.length < 2) return;
    headingEl.innerHTML = parts
      .map((line) => {
        const span = document.createElement('span');
        span.textContent = line;
        return span.innerHTML;
      })
      .join('<br />');
  }

  document.querySelectorAll('[data-aelein-finish-system]').forEach((root) => {
    const sectionId = root.dataset.sectionId;
    const jsonEl = document.getElementById(`AeleinFinishJson-${sectionId}`);
    if (!jsonEl) return;

    let data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch {
      return;
    }

    const img = root.querySelector('[data-aelein-finish-main-img]');
    const frame = root.querySelector('[data-aelein-finish-rotator]');
    const cards = Array.from(root.querySelectorAll('[data-aelein-finish-card]'));
    const prevBtn = root.querySelector('[data-aelein-finish-prev]');
    const nextBtn = root.querySelector('[data-aelein-finish-next]');
    const selectedName = root.querySelector('[data-aelein-finish-selected-name]');
    const selectedDesc = root.querySelector('[data-aelein-finish-selected-desc]');
    const autoplayMs = 5200;
    let activeIndex = Math.max(0, cards.findIndex((card) => card.classList.contains('is-active')));
    let timer = null;
    let paused = false;
    normalizeFinishHeading(root.querySelector('[data-aelein-finish-heading]'));

    function setActive(btn) {
      cards.forEach((c) => {
        const on = c === btn;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      const nextIndex = cards.indexOf(btn);
      if (nextIndex >= 0) activeIndex = nextIndex;
      if (selectedName) {
        selectedName.textContent = btn ? btn.dataset.optionLabel || '' : '';
      }
      if (selectedDesc) {
        const descEl = btn ? btn.querySelector('.aelein-finish-system__card-desc') : null;
        selectedDesc.textContent = descEl ? descEl.textContent.trim() : '';
      }
    }

    function applyVariant(v) {
      if (!v || !img) return;
      const next = v.hero_src || v.featured_src || v.thumb_src;
      if (next && img.src !== next) {
        img.classList.add('is-changing');
        window.setTimeout(() => {
          img.src = next;
          window.setTimeout(() => img.classList.remove('is-changing'), 80);
        }, 120);
      }
      if (v.hero_width) img.width = v.hero_width;
      if (v.hero_height) img.height = v.hero_height;
    }

    function activateCard(btn, options = {}) {
      if (!btn) return;
      const vid = Number(btn.dataset.variantId);
      const v = data.variants.find((x) => x.id === vid);
      setActive(btn);
      applyVariant(v);
      if (options.restart !== false) restartAutoplay();
    }

    function step(direction, options = {}) {
      if (cards.length < 2) return;
      const nextIndex = (activeIndex + direction + cards.length) % cards.length;
      activateCard(cards[nextIndex], options);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (cards.length < 2) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(() => {
        if (!paused) step(1, { restart: false });
      }, autoplayMs);
    }

    function restartAutoplay() {
      startAutoplay();
    }

    cards.forEach((btn) => {
      btn.addEventListener('click', () => {
        activateCard(btn);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => step(-1));
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => step(1));
    }

    if (frame) {
      frame.addEventListener('mouseenter', () => {
        paused = true;
      });
      frame.addEventListener('mouseleave', () => {
        paused = false;
      });
      frame.addEventListener('focusin', () => {
        paused = true;
      });
      frame.addEventListener('focusout', () => {
        paused = false;
      });
    }

    if (cards[activeIndex]) {
      setActive(cards[activeIndex]);
    }
    startAutoplay();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event.data && event.data.variant;
        if (!variant || !variant.id) return;
        const vid = Number(variant.id);
        const match = data.variants.find((x) => x.id === vid);
        if (!match) return;
        const card = cards.find((c) => Number(c.dataset.variantId) === vid);
        if (card) setActive(card);
        applyVariant(match);
        restartAutoplay();
      });
    }

  });
})();
